<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
    <g clip-path="url(#clip0_7_2086)">
      <path
        d="M26.61 27.36H13.5C9.92443 27.3758 6.49981 28.8032 3.97149 31.3315C1.44316 33.8598 0.0157723 37.2844 -1.40648e-05 40.86C-0.0309198 41.2394 -0.0309198 41.6206 -1.40648e-05 42H25.95C26.0214 40.2731 26.4533 38.5803 27.218 37.0304C27.9826 35.4804 29.0631 34.1075 30.39 33C28.6388 31.5003 27.3316 29.5498 26.61 27.36ZM21 23.64C22.6777 23.6237 24.3333 23.2558 25.86 22.56V15H32.34C32.6378 13.9654 32.7992 12.8964 32.82 11.82C32.82 9.48223 32.1268 7.19695 30.828 5.25317C29.5292 3.30938 27.6831 1.79438 25.5233 0.899749C23.3635 0.00512141 20.9869 -0.228954 18.694 0.227123C16.4012 0.683201 14.295 1.80895 12.642 3.462C10.9889 5.11506 9.86318 7.22118 9.4071 9.51404C8.95103 11.8069 9.1851 14.1835 10.0797 16.3433C10.9744 18.5031 12.4894 20.3492 14.4331 21.648C16.3769 22.9468 18.6622 23.64 21 23.64Z"
        fill="url(#paint0_linear_7_2086)"
      />
      <path
        d="M38.43 33C35.8916 33.0158 33.462 34.0333 31.6699 35.831C29.8777 37.6288 28.8678 40.0615 28.86 42.6V48H48V42.6C48 40.0591 46.9927 37.6218 45.1988 35.8224C43.405 34.0229 40.9709 33.0079 38.43 33ZM45 45H31.86V42.6C31.86 40.8575 32.5522 39.1864 33.7843 37.9543C35.0164 36.7222 36.6875 36.03 38.43 36.03C40.1725 36.03 41.8436 36.7222 43.0757 37.9543C44.3078 39.1864 45 40.8575 45 42.6V45ZM28.86 18V23.4C28.86 23.58 28.86 23.76 28.86 23.94C28.9635 25.758 29.5884 27.5077 30.66 28.98C30.9884 29.4441 31.3601 29.876 31.77 30.27L31.98 30.45C32.3436 30.7828 32.735 31.0839 33.15 31.35L33.69 31.65C34.0203 31.8478 34.3607 32.0281 34.71 32.19L35.67 32.49L36.45 32.73C37.0729 32.8493 37.7057 32.9096 38.34 32.91C38.9744 32.9124 39.6075 32.8521 40.23 32.73L41.01 32.49L41.97 32.19C42.329 32.0281 42.6794 31.8478 43.02 31.65C43.1995 31.5671 43.3703 31.4666 43.53 31.35C43.9449 31.0839 44.3364 30.7828 44.7 30.45L44.91 30.27C45.3293 29.8764 45.711 29.4445 46.05 28.98C47.1645 27.5416 47.8414 25.8127 48 24C48 23.82 48 23.64 48 23.46V18H28.86ZM45 23.46C45.0147 23.6397 45.0147 23.8203 45 24H31.92C31.92 23.82 31.92 23.64 31.92 23.46V21H45V23.46Z"
        fill="url(#paint1_linear_7_2086)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_7_2086"
        x1="-0.0231934"
        y1="0"
        x2="40.8094"
        y2="31.713"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" stop-color="#DF252A" />
        <stop offset="1" stop-color="#A20004" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_7_2086"
        x1="28.86"
        y1="18"
        x2="56.0802"
        y2="35.2483"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" stop-color="#DF252A" />
        <stop offset="1" stop-color="#A20004" />
      </linearGradient>
      <clipPath id="clip0_7_2086">
        <rect width="48" height="48" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
